import React from 'react';
import { useSelector } from 'react-redux';
import { SubmissionStatus } from '../../../../../redux/form/types';
import { getCurrentSubmission } from '../../../../../redux/form/selectors';
import PromptError from '../../partials/PromptError';
const ErrorArea = ({ className })=>{
    const currentSubmission = useSelector(getCurrentSubmission);
    return /*#__PURE__*/ React.createElement("div", {
        "aria-live": "polite",
        className: className
    }, currentSubmission.status === SubmissionStatus.Error && /*#__PURE__*/ React.createElement(PromptError, null));
};
ErrorArea.displayName = 'ErrorArea';
export default ErrorArea;

//# sourceMappingURL=ErrorArea.js.map